import React from 'react'
import PropTypes from 'prop-types'
import { AlertsProvider, DialogsProvider } from '@theneatcompany/nui'
import { IntlProvider } from 'react-intl'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { ReCaptchaProvider } from 'next-recaptcha-v3'
import SignUpProvider from '@paper-monster/web/src/components/Providers/SignUpProvider'
import { mergeMessages } from '@paper-monster/web/src/components/Providers/SiteConfigProvider'
import { useNonce } from '@paper-monster/web/src/utils/nonce'

import { GOOGLE_SIGN_IN_ID, RECAPTCHA_V3_SITE_KEY, SITE_CONFIG } from '@/config'

const DEFAULT_LOCALE = 'en-US'
const MESSAGES = mergeMessages(SITE_CONFIG.messages)

export default function Providers({ children }) {
  const nonce = useNonce()

  return (
    <ReCaptchaProvider
      nonce={nonce}
      reCaptchaKey={RECAPTCHA_V3_SITE_KEY}
    >
      <IntlProvider
        formats={{
          number: {
            usd: { style: 'currency', currency: 'USD' },
          },
        }}
        locale={DEFAULT_LOCALE}
        messages={MESSAGES}
      >
        <AlertsProvider>
          <DialogsProvider>
            <SignUpProvider>
              <GoogleOAuthProvider clientId={GOOGLE_SIGN_IN_ID}>
                {children}
              </GoogleOAuthProvider>
            </SignUpProvider>
          </DialogsProvider>
        </AlertsProvider>
      </IntlProvider>
    </ReCaptchaProvider>
  )
}

Providers.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
}
